import React from "react";

// Uses inline styles only - must render even if CSS bundles fail to load
export class RootErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[CONNECT] App crashed:", error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          data-testid="root-error-screen"
          style={{
            minHeight: "100vh",
            background: "#0F172A",
            color: "#E2E8F0",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "sans-serif",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "20px", marginBottom: "8px" }}>Something went wrong</h1>
          <p style={{ fontSize: "14px", color: "#94A3B8", maxWidth: "480px", marginBottom: "16px" }}>
            {String(this.state.error?.message || this.state.error)}
          </p>
          <button
            data-testid="root-error-reload-btn"
            onClick={() => window.location.reload()}
            style={{
              background: "#3B82F6",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              padding: "10px 24px",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Reload App
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
